export default __webpack_public_path__ + "static/media/arctic-logo-black.d4983d15.png";